'use strict';

const Backbone = require('backbone');
const Template = require('system/ui/template/detail/description-viewer.hbs');

const ElementDescriptionViewerView = Backbone.View.extend({

    initialize: function(params) {

    },

    render: function(json) {
        this.$el.html(Template(json));

        this.$content = this.$('.modal-body .description-content');
        const self = this;

        this.$content.css('display', 'none');

        const fitResize = function() {
            const height = $(window).height() - 120
                - self.$('.modal-header').outerHeight()
                - self.$('.modal-footer').outerHeight();
            self.$('.modal-body').css('height', height);

            self.$content.css('display', 'block');
        };
        this.$('.description-modal').on('shown.bs.modal', function() {
            fitResize();
            $(window).on('resize', fitResize);
        });
        this.$('.description-modal').on('hide.bs.modal', function() {
            $(window).off('resize', fitResize);
        });

        return this;
    }
});

module.exports = ElementDescriptionViewerView;



// WEBPACK FOOTER //
// ./system/ui/view/detail/description-viewer.js